export const selectAppConfig = (state) => state.appConfig;
